/* eslint-disable */
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Anglichannka API
 * Includes personal account entities
 * OpenAPI spec version: 1.0
 */
import { httpClient } from '../../api';
import type {
  ActivateAccount408,
  ActivateAccount429,
  ActivateAccount500,
  ActivateAccountDto,
  Login408,
  Login429,
  Login500,
  LoginDto,
  Logout408,
  Logout429,
  Logout500,
  RefreshToken408,
  RefreshToken429,
  RefreshToken500,
} from '.././model';

/**
 * Authenticates user by creating and setting access and refresh tokens in cookies
 * @summary Authenticates user by creating and setting JWT tokens
 */
export type loginResponse200 = {
  data: null;
  status: 200;
};

export type loginResponse408 = {
  data: Login408;
  status: 408;
};

export type loginResponse429 = {
  data: Login429;
  status: 429;
};

export type loginResponse500 = {
  data: Login500;
  status: 500;
};

export type loginResponseComposite = loginResponse200 | loginResponse408 | loginResponse429 | loginResponse500;

export type loginResponse = loginResponseComposite & {
  headers: Headers;
};

export const getLoginUrl = () => {
  return `https://api-stage.anglichannka.ru/v1/auth/login`;
};

export const login = async (loginDto: LoginDto, options?: RequestInit): Promise<loginResponse> => {
  return httpClient<loginResponse>(getLoginUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(loginDto),
  });
};

/**
 * Activates account
 * @summary Activates account
 */
export type activateAccountResponse200 = {
  data: ActivateAccountDto;
  status: 200;
};

export type activateAccountResponse408 = {
  data: ActivateAccount408;
  status: 408;
};

export type activateAccountResponse429 = {
  data: ActivateAccount429;
  status: 429;
};

export type activateAccountResponse500 = {
  data: ActivateAccount500;
  status: 500;
};

export type activateAccountResponseComposite =
  | activateAccountResponse200
  | activateAccountResponse408
  | activateAccountResponse429
  | activateAccountResponse500;

export type activateAccountResponse = activateAccountResponseComposite & {
  headers: Headers;
};

export const getActivateAccountUrl = () => {
  return `https://api-stage.anglichannka.ru/v1/auth/activate`;
};

export const activateAccount = async (
  activateAccountDto: ActivateAccountDto,
  options?: RequestInit,
): Promise<activateAccountResponse> => {
  return httpClient<activateAccountResponse>(getActivateAccountUrl(), {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(activateAccountDto),
  });
};

/**
 * Refreshes access token using valid refresh token
 * @summary Refreshes access token
 */
export type refreshTokenResponse200 = {
  data: null;
  status: 200;
};

export type refreshTokenResponse408 = {
  data: RefreshToken408;
  status: 408;
};

export type refreshTokenResponse429 = {
  data: RefreshToken429;
  status: 429;
};

export type refreshTokenResponse500 = {
  data: RefreshToken500;
  status: 500;
};

export type refreshTokenResponseComposite =
  | refreshTokenResponse200
  | refreshTokenResponse408
  | refreshTokenResponse429
  | refreshTokenResponse500;

export type refreshTokenResponse = refreshTokenResponseComposite & {
  headers: Headers;
};

export const getRefreshTokenUrl = () => {
  return `https://api-stage.anglichannka.ru/v1/auth/refresh`;
};

export const refreshToken = async (options?: RequestInit): Promise<refreshTokenResponse> => {
  return httpClient<refreshTokenResponse>(getRefreshTokenUrl(), {
    ...options,
    method: 'POST',
  });
};

/**
 * Logs out user by clearing cookies and invalidating refresh token
 * @summary Logs out user
 */
export type logoutResponse200 = {
  data: null;
  status: 200;
};

export type logoutResponse408 = {
  data: Logout408;
  status: 408;
};

export type logoutResponse429 = {
  data: Logout429;
  status: 429;
};

export type logoutResponse500 = {
  data: Logout500;
  status: 500;
};

export type logoutResponseComposite = logoutResponse200 | logoutResponse408 | logoutResponse429 | logoutResponse500;

export type logoutResponse = logoutResponseComposite & {
  headers: Headers;
};

export const getLogoutUrl = () => {
  return `https://api-stage.anglichannka.ru/v1/auth/logout`;
};

export const logout = async (options?: RequestInit): Promise<logoutResponse> => {
  return httpClient<logoutResponse>(getLogoutUrl(), {
    ...options,
    method: 'POST',
  });
};
